import QbLogoFullName from '../../../../components/Icons/QbLogoFullName';

interface SplashScreenProps {
  fadeOut: boolean;
  fadeOutTime: number;
}

function SplashScreen({ fadeOut, fadeOutTime }: SplashScreenProps) {
  return (
    <div
      className="h-full w-full flex flex-col items-center justify-center"
      style={{
        opacity: fadeOut ? '0%' : '100%',
        transition: `opacity ${fadeOutTime}ms ease-in-out`,
      }}
    >
      <QbLogoFullName size={'md'} />
      <h2 className=" mt-2">Euer Trinkspiel</h2>
    </div>
  );
}

export default SplashScreen;
